module.exports = __webpack_public_path__ + "static/swappurple-35d4ccc6dad7eb9f6a83dbf3b2a822da.svg";